import { render, staticRenderFns } from "./DcmComponent.vue?vue&type=template&id=5a11ce2d&"
import script from "./DcmComponent.vue?vue&type=script&lang=js&"
export * from "./DcmComponent.vue?vue&type=script&lang=js&"
import style0 from "./DcmComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports